import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"


import { Trash2 } from "lucide-vue-next";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Loader2 } from 'lucide-vue-next'
import { cn } from "@/lib/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteConfirmationDialog',
  props: {
    open: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["confirm", "update:open"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const handleDelete = () => {
  emit("confirm");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: _ctx.open,
    "onUpdate:open": _cache[1] || (_cache[1] = (value) => _ctx.$emit('update:open', value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), { class: "flex gap-2 items-center text-2xl" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" Confirmar Exclusão ")
                ])),
                _: 1
              }),
              _createVNode(_unref(DialogDescription), { class: "text-base py-4" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Você tem certeza que deseja deletar este item? Esta ação não pode ser revertida. ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogFooter), { class: "sm:justify-start" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                type: "button",
                variant: "secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:open', false))),
                class: "w-full sm:w-auto"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Cancelar ")
                ])),
                _: 1
              }),
              _createVNode(_unref(Button), {
                type: "button",
                variant: "destructive",
                disabled: _ctx.loading,
                onClick: handleDelete,
                class: _normalizeClass(_unref(cn)(
            'w-full sm:w-auto',
            'bg-red-500 hover:from-red-600 hover:to-pink-600',
            'border-0 text-white font-semibold'
          ))
              }, {
                default: _withCtx(() => [
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_unref(Loader2), {
                        key: 0,
                        class: "w-4 h-4 animate-spin"
                      }))
                    : _createCommentVNode("", true),
                  _cache[5] || (_cache[5] = _createTextVNode(" Deletar "))
                ]),
                _: 1
              }, 8, ["disabled", "class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})